import React from 'react'
import axios from 'axios'

import TeacherSignUpExplanation from './TeacherSignUpExplanation'
import SchoolZoneHeader from './header'
import TeacherSignUpUsefulness from './TeacherSignUpUsefulness'
import TeacherSignUpGuideReviews from './TeacherSignUpGuideReviews'
import getStrings from 'getStrings'


class TeacherSignUp extends React.Component {
    constructor(props) {
        super(props)
        
        this.state = {
            mounted: false,
        }
    }
    
    componentDidMount() {
        if (process.env.hasOwnProperty('REACT_APP_SCHOOLZONE_TEACHER_REDIRECT') && process.env['REACT_APP_SCHOOLZONE_TEACHER_REDIRECT'] !== 'None')
            window.location.href = process.env['REACT_APP_SCHOOLZONE_TEACHER_REDIRECT']
        
        document.title = 'Math Makers Teacher SignUp'

        axios.get('https://geolocation-db.com/json/').then(result => {
            const logData = {
                type: 'PageView',
                timestamp: Date.now(),
                data: JSON.stringify({
                    page: document.title,
                    ...result.data
                })
            }
            axios.post(`${process.env['REACT_APP_ANALYTICS_API']}/log`, logData).then(() => {})
        })
        .catch((err) => console.error('Failed to GET geolocation-db with error: ', err))

        this.setState({
            mounted: true
        })
    }

    render() {
        if (!this.state.mounted)
            return "";

        const strings = getStrings()

        return (
            <>
                <div className='schoolzone-hero'>
                    <SchoolZoneHeader />
                    <div className='container text-center'>
                        <div className='title-wrap'>
                            <img src={'/images/MathMakers_Title.png'} alt='Math Makers' />
                            <p className='by-ululab'>{strings.TEACHER_LOUNGE_BY_ULULAB}</p>
                        </div>
                        <h1 className='text-white margin-top-4' dangerouslySetInnerHTML={{__html: strings.TEACHER_LOUNGE_HEADER}}></h1>
                        <h2 className='text-white' dangerouslySetInnerHTML={{__html: strings.TEACHER_LOUNGE_SUBTITLE}}></h2>
                    </div>
                    <img className='schoolzone-hero--line-img full-width margin-top-4' src={'/images/Numberlines_Illustration.png'} alt="" />
                </div>
                <TeacherSignUpExplanation />
                <TeacherSignUpUsefulness />
                <TeacherSignUpGuideReviews />
            </>
        )
    }
}

export default TeacherSignUp